import { Mountain, Flame, Footprints, Dog, Coffee, Wifi, Sunrise, Moon } from "lucide-react";
import { AMENITIES } from "@/data";
import { Reveal } from "@/components/Reveal";

const ICONS = { Mountain, Flame, Footprints, Dog, Coffee, Wifi, Sunrise, Moon };

export const Amenities = () => (
  <section id="amenities" data-testid="amenities-section" className="bg-charcoal text-cream py-24 md:py-40">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="max-w-2xl mb-16 md:mb-24">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-amber mb-6">
            (What&rsquo;s here)
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Little comforts, <span className="italic text-mist-light">big quiet.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12 md:gap-y-16">
        {AMENITIES.map((a, i) => {
          const Icon = ICONS[a.icon];
          return (
            <Reveal key={a.title} delay={(i % 4) * 0.06} data-testid={`amenity-${i}`}>
              <div className="group border-t border-cream/15 pt-6">
                <Icon size={30} strokeWidth={1.25} className="text-amber mb-5 transition-transform duration-500 group-hover:-translate-y-1" />
                <h3 className="font-serif text-xl md:text-2xl mb-2">{a.title}</h3>
                <p className="font-sans text-sm text-cream/60 leading-relaxed">{a.note}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
